module.exports = __webpack_public_path__ + "static/media/fifth-image.ddd31007.png";